/* eslint-disable react-hooks/exhaustive-deps */

import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useManageTable } from "hooks";
import { GetListRequestParams } from "libs/api";

import { useGetReturns } from "../apis";

const useReturnsList = () => {
  const {
    page,
    searchValue,
    debouncedSearch,
    sorting,
    setSorting,
    setSearchValue,
    setPage
  } = useManageTable();

  const requestParams: GetListRequestParams = {
    page,
    take: GET_LIST_REQUEST_DEFAULT_LIMIT,
    search: debouncedSearch,
    orderBy: sorting[0]?.id,
    order: sorting[0] ? (sorting[0]?.desc ? "DESC" : "ASC") : "DESC"
  };

  const {
    returns,
    meta,
    isLoading,
    refetch: refetchReturns
  } = useGetReturns(requestParams);

  return {
    returns,
    totalItems: meta?.itemCount ?? 0,
    searchValue,
    page,
    isLoading,
    sorting,
    setSorting,
    setSearchValue,
    setPage,
    refetchReturns
  };
};

export default useReturnsList;
